// CaloriesCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { Calories_EndPoint } from "./ConstantsHealthCalculator";
import CaloriesTable from "./CaloriesTable";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Kalori (BMR)";
const DESCRIPTION =
  "Kalkulator kalori adalah perhitungan yang menghitung jumlah kalori yang dikonsumsi setiap hari oleh seseorang (pria/wanita) berdasarkan beberapa faktor seperti berat badan, tinggi badan, usia, dan jenis aktivitas fisik harian";
const KEYWORDS =
  "cara menghitung kalori yang dibutuhkan tubuh, metode menghitung kalori tubuh, hitung kalori yang dibutuhkan tubuh per hari, hitung kalori berdasarkan berat badan, rumus hitung kalori, kalkulator kalori";
const OG_URL = "https://do-calculate.com/calculator/id/calories/";
const apiEndpoint = `${SERVER_URL}/${Calories_EndPoint}`;
function CaloriesCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [activity, setActivity] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleActivityChange = (event) => {
    setActivity(event.target.value);
  };
  const calculateCalories = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ activity, weight, height, age, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator kalori adalah perhitungan yang menghitung jumlah kalori yang dikonsumsi setiap hari oleh seseorang (pria/wanita) berdasarkan beberapa faktor seperti berat badan, tinggi badan, usia, dan jenis aktivitas fisik harian. Anda dapat menghitung kalori tubuh Anda dan memperkirakan berapa banyak kalori yang dibutuhkan tubuh. Anda juga dapat menggunakan kalkulator ini untuk mengetahui kalori yang diperlukan untuk menambah dan menurunkan berat badan
                <br />
                Kalkulator ini memperhitungkan faktor-faktor seperti tingkat aktivitas fisik, berat badan, tinggi badan, usia, dan jenis kelamin untuk memberikan rekomendasi kalori yang dipersonalisasi untuk kebutuhan tubuh individu Anda. Selain itu, ini memberi Anda panduan sederhana untuk manajemen berat badan, termasuk penurunan berat badan atau penambahan berat badan dan mencapai keseimbangan yang sehat berdasarkan kalori yang dibutuhkan tubuh Anda setiap hari.
                <br />
                Gunakan kalkulator kalori untuk mengetahui berapa banyak kalori yang dibutuhkan tubuh Anda untuk mempertahankan berat badan yang sehat dan gaya hidup aktif
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalori untuk Menambah/Menurunkan Berat Badan
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Tinggi Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="heightNumber"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Berat Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      Usia
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >Jenis Kelamin</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="male"
                      name="gender"
                      value="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      Laki-laki
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="female"
                      value="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      Perempuan
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="activitySelect" className="form-label ms-2">
                      Tingkat Aktivitas
                    </label>
                  </b>
                  <select
                    id="activitySelect"
                    className="form-select"
                    value={activity}
                    onChange={handleActivityChange}
                  >
                    <option value="">-- Pilih Aktivitas --</option>
                    <option value="sedentary">
                      Kurang Aktif: aktivitas fisik sangat sedikit atau tidak ada olahraga
                    </option>
                    <option value="lightlyActive">
                      Cukup Aktif: olahraga ringan atau aktivitas fisik 1-3 hari per minggu
                    </option>
                    <option value="moderatelyActive">
                      Aktif Sedang: olahraga sedang atau aktivitas fisik 3-5 hari per minggu
                    </option>
                    <option value="active">
                      Aktif Tinggi: olahraga intens atau aktivitas fisik 6-7 hari per minggu
                    </option>
                    <option value="veryActive">
                      Sangat Aktif: olahraga sangat intens atau aktivitas fisik berat setiap hari
                    </option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateCalories}
                  disabled={isLoading}
                >
                  Hitung
                </button>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>Hasil : </h5>
                    </div>
                    <hr />
                    <CaloriesTable
                      caloriesBurned={result.caloriesBurned}
                      bmr={result.bmr}
                      maintain={result.dailyCalories.maintain}
                      mildLoss={result.dailyCalories.mildLoss}
                      lose={result.dailyCalories.lose}
                      extremeLoss={result.dailyCalories.extremeLoss}
                      mildGain={result.dailyCalories.mildGain}
                      gain={result.dailyCalories.gain}
                      extremeGain={result.dailyCalories.extremeGain}
                    ></CaloriesTable>{" "}
                    <br />
                    <div className="alert alert-warning">
                      Ketika Anda kehilangan 0,5 kg atau lebih per minggu, silakan berkonsultasi dengan dokter.
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua kolom dengan benar.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Kalkulator Kalori - Berapa Banyak Kalori yang Dibutuhkan Tubuh:
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Kalori dan Cara Menghitungnya untuk Mencapai Nutrisi yang Tepat{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Kalori adalah salah satu konsep terpenting dalam dunia nutrisi dan kesehatan. Mengetahui jumlah kalori yang dibutuhkan tubuh Anda dapat menjadi kunci untuk mencapai nutrisi yang tepat dan mempertahankan berat badan yang sehat. Dalam artikel ini, kita akan belajar cara menghitung kalori yang dibutuhkan tubuh Anda dan pentingnya dalam menjaga kesehatan Anda.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}> Apa itu Kalori?</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Kalori adalah satuan ukuran energi. Ini adalah energi yang digunakan tubuh Anda untuk melakukan fungsi dasarnya seperti bernapas, memompa darah, dan fungsi organ lainnya. Ini juga membutuhkan energi untuk melakukan aktivitas fisik atau gerakan apa pun, baik Anda berolahraga di gym atau melakukan tugas sehari-hari.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Kalori yang Dibutuhkan Tubuh{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                Ada banyak cara untuk menghitung kalori yang dibutuhkan tubuh Anda, tetapi metode yang paling umum didasarkan pada faktor-faktor berikut:
                <ul>
                  <li>
                    Berat badan: semakin besar berat badan Anda, semakin besar kebutuhan kalori tubuh Anda untuk mempertahankan fungsi vitalnya.
                  </li>
                  <li>
                    Tinggi badan: orang yang lebih tinggi biasanya membutuhkan lebih banyak kalori karena lebih banyak sel dan jaringan dalam tubuh mereka.
                  </li>
                  <li>
                    Usia: seiring bertambahnya usia, Anda mungkin membutuhkan lebih sedikit kalori karena perubahan laju metabolisme.
                  </li>
                  <li>
                    Aktivitas fisik: orang yang berolahraga secara teratur membutuhkan lebih banyak kalori untuk memenuhi kebutuhan aktivitas fisik.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Aplikasi Perhitungan Kalori:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Anda juga dapat menggunakan aplikasi smartphone dan alat online untuk menghitung kalori harian yang Anda butuhkan berdasarkan informasi pribadi Anda. Aplikasi ini membuat prosesnya lebih mudah dan lebih akurat. Singkatnya, memahami kalori dan cara menghitungnya sangat penting untuk menjaga kesehatan Anda dan mempertahankan berat badan yang sehat. Pastikan untuk memenuhi kebutuhan kalori tubuh Anda dan memilih makanan sehat yang mengandung nutrisi yang diperlukan untuk mencapai keseimbangan nutrisi dan kesehatan secara keseluruhan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Rumus Perhitungan Kalori:
                  </h2>{" "}
                </u>
                <br />
                Laju metabolisme basal (BMR) dihitung berdasarkan usia, berat badan, tinggi badan, dan jenis kelamin menggunakan rumus Harris-Benedict yang direvisi. Persamaan Harris-Benedict adalah salah satu persamaan tertua yang digunakan untuk menghitung BMR, yang merupakan jumlah energi yang dikeluarkan setiap hari saat istirahat. Itu direvisi pada tahun 1984 agar lebih akurat.
                <br /> <hr />
                <b>Persamaan Harris-Benedict yang Direvisi : </b>
                <br />
                <div className="alert alert-info text-center">
                  <b>
                    <u>Laki-laki: </u>
                  </b>{" "}
                  <label>
                    BMR = 13,397W + 4,799H - 5,677A + 88,362
                  </label>{" "}
                  <br />
                  <b>
                    <u>Perempuan: </u>
                  </b>{" "}
                  <label>
                    BMR = 9,247W + 3,098H - 4,33A + 447,593
                  </label>
                </div>
                <div>
                  Di mana:
                  <ul>
                    <li>W adalah berat badan dalam kilogram</li>
                    <li>H adalah tinggi badan dalam sentimeter</li>
                    <li>A adalah usia</li>
                  </ul>
                </div>
                <br />
                <hr />
                Total kalori yang terbakar dihitung berdasarkan tingkat aktivitas dan BMR.
                <br />
                Perkiraan kalori harian dihitung berdasarkan target berat badan yang diinginkan, termasuk mempertahankan berat badan, menurunkan berat badan, dan menambah berat badan.
                <hr />
                <p>
                  Kalkulator ini menghitung jumlah kalori yang terbakar dan BMR berdasarkan tingkat aktivitas, berat badan, tinggi badan, usia, dan jenis kelamin. Untuk anak-anak dan remaja berusia 2 hingga 20 tahun, kalkulator BMI memperhitungkan usia dan jenis kelamin serta tinggi dan berat badan.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Berapa banyak kalori yang Anda butuhkan?
                </h3>
              </div>
              <div className="info-section-body">
                Jumlah kalori yang Anda butuhkan tergantung pada usia, ukuran tubuh, dan tingkat aktivitas Anda - kebanyakan remaja dan dewasa membutuhkan sekitar 1500 hingga 2500 kalori per hari. Semakin besar ukuran Anda, semakin banyak kalori yang Anda butuhkan untuk mempertahankan berat badan Anda. Jika Anda ingin menambah berat badan, Anda perlu makan lebih banyak kalori, dan jika Anda ingin menurunkan berat badan, Anda perlu makan lebih sedikit kalori atau berolahraga lebih banyak. Anda dapat menghitung kebutuhan kalori Anda menggunakan rumus Harris-Benedict.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Berapa banyak kalori dalam lemak?
                </h3>
              </div>
              <div className="info-section-body">
                Lemak mengandung sekitar 9 kalori per gram, dan dianggap sebagai salah satu sumber kalori tinggi. Ketika lemak dikonsumsi dalam jumlah besar, dapat berkontribusi pada peningkatan jumlah kalori yang Anda konsumsi setiap hari dan dengan demikian penambahan berat badan jika aktivitas fisik tidak cukup untuk membakarnya.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa pengaruh aktivitas fisik terhadap kalori?
                </h3>
              </div>
              <div className="info-section-body">
                Bergerak, mengangkat benda, dan melakukan berbagai aktivitas membutuhkan energi, jadi semakin banyak Anda bergerak dan semakin banyak benda yang Anda angkat, dorong, atau tarik, semakin banyak kalori yang Anda butuhkan untuk tujuan energi. Selain itu, latihan ketahanan yang meningkatkan massa otot meningkatkan laju metabolisme, yang berarti tubuh Anda membutuhkan lebih banyak kalori - bahkan ketika Anda tidak melakukan banyak aktivitas. Oleh karena itu, membangun otot adalah cara yang baik untuk membantu Anda mencapai berat badan yang sehat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Seberapa akurat kalkulator kalori?
                </h3>
              </div>
              <div className="info-section-body">
                Kalkulator kalori cukup akurat, tetapi mungkin tidak 100% akurat. Kebanyakan didasarkan pada rumus Harris-Benedict, yang menentukan BMR yang pada dasarnya berarti jumlah kalori yang Anda butuhkan hanya untuk tetap hidup dan terjaga. Kalkulator kalori juga perlu mempertimbangkan tingkat aktivitas harian Anda yang biasa, yang mungkin merupakan perkiraan yang lebih besar. Sulit untuk mengetahui dengan tepat berapa banyak kalori yang Anda bakar dengan aktivitas fisik dan itu mungkin berbeda setiap hari. Kalkulator kalori ini adalah cara yang baik untuk memulai, tetapi jika Anda merasa berat badan Anda tidak cukup berubah, Anda mungkin perlu menyesuaikan asupan kalori harian atau pengeluaran pembakaran Anda sesuai kebutuhan.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa cara terbaik untuk melacak kalori?
                </h3>
              </div>
              <div className="info-section-body">
                Anda dapat menggunakan buku catatan atau jurnal makanan di atas kertas dan mencari jumlah kalori dan kamus kalori serta melakukan perhitungan secara manual. Namun saat ini, cara terbaik adalah menggunakan situs web atau aplikasi pelacak kalori, seperti MyFitnessPal. Anda dapat memilih makanan yang Anda makan dan minuman yang Anda minum, dan situs web akan menghitung kalori dan memberi Anda perkiraan nutrisi harian. Selain itu, Anda dapat melacak kalori yang dibakar tubuh Anda setiap hari. Dan gratis.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa yang dimaksud dengan "tidak semua kalori sama"?
                </h3>
              </div>
              <div className="info-section-body">
                Semua kalori sama dalam hal energi. Setiap gram karbohidrat mengandung empat kalori, setiap gram protein mengandung empat kalori, dan setiap gram lemak mengandung sembilan kalori. Itu tidak berubah. Ungkapan "tidak semua kalori sama" berarti bahwa beberapa sumber kalori lebih baik daripada yang lain. Singkatnya, Anda harus mendapatkan sebagian besar kalori Anda dari makanan yang kaya nutrisi. Jadi, meskipun 250 kalori dari cokelat dapat digunakan dengan cara yang sama seperti 250 kalori dari pisang, apel, atau pir, buah-buahan tentu saja lebih baik untuk kesehatan Anda.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default CaloriesCalculator;